module.exports = __webpack_public_path__ + "abc55b90d0bc9047f9540a162fdec41d.png";